/* eslint-disable no-use-before-define */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
// eslint-disable-next-line import/no-cycle
import { ModalContext } from './modalContext';
import close from './assets/close.svg';
import closeWhite from './assets/close-w.svg';
import { ModalBackground, ModalContainer, ModalButtonClose } from './styledComponentModal';

const Modal = () => {
  const modalContext = useContext(ModalContext);
  const [data, setData] = useState({ ...modalContext, ...modalContext.modalSettings });
  const [isOpen, setIsOpen] = useState(data.modal);

  useEffect(() => {
    setData({ ...modalContext, ...modalContext.modalSettings });
    setIsOpen(modalContext.modal);
  }, [modalContext]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    if (data.onClose) data.onClose();
  }, [data]);

  useEffect(() => {
    const handleKeydown = e => {
      if (data.escClose && e.key === 'Escape') {
        handleClose();
      }
    };

    if (isOpen && data.escClose) {
      document.addEventListener('keydown', handleKeydown);
    } else {
      document.removeEventListener('keydown', handleKeydown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [isOpen, data.escClose, handleClose]);

  const handleClickBackground = e => {
    if (e.target === e.currentTarget && data.backgroundClose) {
      handleClose();
    }
  };

  if (isOpen) {
    const containerId = data.modalId || 'modal-mount';
    let modalContainer = document.getElementById(containerId);

    if (!modalContainer) {
      modalContainer = document.createElement('div');
      modalContainer.setAttribute('id', containerId);
      modalContainer.setAttribute('data-qa', 'modal-container');
      document.body.appendChild(modalContainer);
    }

    return createPortal(
      <ModalBackground
        padding={data.paddingBackground}
        noBackgroundOpacity={data.noBackgroundOpacity}
        openFrom={data.openFrom}
        onClick={handleClickBackground}
        xAlign={data.xAlign}
        top={data.top}
        maxContent={data.maxContent}
      >
        <ModalContainer
          width={data.width}
          height={data.height}
          padding={data.padding}
          openFrom={data.openFrom}
          animation={data.animation}
          overflow={data.overflow}
        >
          {data.buttonClose && (
            <ModalButtonClose data-qa='MENU_MOBILE_CLOSE' id='modalButtonClose' onClick={handleClose}>
              <img src={data.darkClose ? closeWhite : close} alt='Close' />
            </ModalButtonClose>
          )}

          {data.modalContent}
        </ModalContainer>
      </ModalBackground>,
      modalContainer
    );
  }

  return null;
};

export default Modal;
